import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import { truncate } from 'flarum/common/utils/string';
export default class FirstPostApprovalNotification extends Notification {
  icon() {
    return 'fas fa-check-circle';
  }
  href() {
    return app.route.post(this.attrs.notification.subject());
  }
  content() {
    const notification = this.attrs.notification;
    const user = notification.fromUser();
    return m('span', [user ? m('strong', user.displayName()) : m('strong', 'Un membre'), ' a publié un message à approuver']);
  }
  excerpt() {
    const post = this.attrs.notification.subject();
    return post ? truncate(post.contentPlain(), 200) : '';
  }
}